"use strict";

var DateTimeField, FormDateTimeField, HelpMixin, React, SingleInputMixin, StandardErrorDisplayMixin;

React = require("react");

SingleInputMixin = require("./mixins/SingleInput");

StandardErrorDisplayMixin = require("./mixins/StandardErrorDisplay");

HelpMixin = require("./mixins/Help");

DateTimeField = require("react-bootstrap-datetimepicker");

FormDateTimeField = React.createClass({
  displayName: "FormDateTimeField",

  mixins: [SingleInputMixin, StandardErrorDisplayMixin, HelpMixin],
  propTypes: {
    dataKey: React.PropTypes.string
  },
  onChange: function onChange(value) {
    return this.props.onDataChanged(this.props.dataKey, value);
  },
  render: function render() {
    return React.createElement(
      "div",
      { className: this.errorClasses("form-group") },
      React.createElement(
        "label",
        { className: "col-sm-2 control-label", htmlFor: this.props.dataKey },
        this.props.displayName
      ),
      React.createElement(
        "div",
        { className: "col-sm-5" },
        React.createElement(DateTimeField, { onChange: this.onChange, dateTime: this.props.data, format: "MM/DD/YY H:mm A", inputFormat: "MM/DD/YY H:mm A", direction: this.props.direction }),
        this.errorSpan(),
        this.helpSpan()
      )
    );
  }
});

module.exports = FormDateTimeField;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/DateTime.js
 ** module id = 338
 ** module chunks = 0
 **/